<template>
  <svg
    :width="width"
    :height="height"
    class="icon-breed"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.14648 12.7129H5.87891V20H1.77734V0.09375H9.17383C11.5254 0.09375 13.3392 0.617839 14.6152 1.66602C15.8913 2.71419 16.5293 4.19531 16.5293 6.10938C16.5293 7.46745 16.2331 8.60221 15.6406 9.51367C15.0573 10.416 14.1686 11.1361 12.9746 11.6738L17.2812 19.8086V20H12.8789L9.14648 12.7129ZM5.87891 9.39062H9.1875C10.2174 9.39062 11.015 9.13086 11.5801 8.61133C12.1452 8.08268 12.4277 7.35807 12.4277 6.4375C12.4277 5.4987 12.1589 4.76042 11.6211 4.22266C11.0924 3.6849 10.2767 3.41602 9.17383 3.41602H5.87891V9.39062Z"
      fill="#495057"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconBreed',
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 16,
    },
  },
};
</script>

<style scoped>
</style>